export const PROVIDER_SERVICE_LISTING_ROUTES = {
  get: '/provider-service-listings',
  patch: '/provider-service-listings/{listingId}',
  post: '/provider-service-listings',
};

export const PROVIDER_SERVICE_LISTING_DETAIL_ROUTES = {
  get: '/provider-service-listings/{listingId}',
};

export const PROVIDER_SERVICE_LISTING_ACTIVATE_ROUTES = {
  patch: '/provider-service-listings/{listingId}/activate',
};

export const PROVIDER_SERVICE_LISTING_PAUSE_ROUTES = {
  patch: '/provider-service-listings/{listingId}/pause',
};

export const PROVIDER_SERVICE_LISTING_ARCHIVE_ROUTES = {
  patch: '/provider-service-listings/{listingId}/archive',
};

export const PROVIDER_SERVICE_LICENSE_STATE_SUGGESTIONS_ROUTES = {
  get: '/provider-service-listings/license-state-suggestions',
};

export const GEOGRAPHY_SEARCH_ROUTES = {
  get: '/geographies/search',
};
